export default __webpack_public_path__ + "images/GU.33d3502.png";